import type { AppServiceType } from '@/backend/market'
import type { ChannelStatus } from '../enums/ChannelStatusEnum'
import type { ChannelType } from '../enums/ChannelTypeEnum'
import type { ChannelItemType } from '../enums/ChannelItemTypeEnum'
import type { LayoutEntity } from './LayoutEntity'

export class ChannelMiniEntity {
  id?: number
  coverImageUrl?: string | null
  color?: string | null
  profileImageUrl?: string | null
  name?: string | null
  subtitle?: string | null
  type?: ChannelType
  status?: ChannelStatus
  branchesCount?: number
  appServiceType?: AppServiceType | null
  itemType?: ChannelItemType | null
  layouts?: LayoutEntity[] | null
}
